<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { ChevronLeftIcon } from "@heroicons/vue/24/solid";
import CreateFontStep1 from "@/components/Lists/Schemes/CreateFontStep1";
import ListsTable from "@/components/Lists/Schemes/ListsTable.vue";

const route = useRoute();
const showCreateFontStep1 = ref(false);
const cardOpen = ref(false);
const keys = ref([]);
const createFontKey = ref(0);

function toggleCreateStep1() {
  createFontKey.value += 1;
  showCreateFontStep1.value = true;
}

function closeCreateStep1() {
  showCreateFontStep1.value = false;
}

function handleNestedOpen() {
  cardOpen.value = true;
}

function handleNestedClose() {
  cardOpen.value = false;
}
</script>

<template>
  <div v-if="route.name === 'DashboardLists'">
    <div v-if="!showCreateFontStep1">
      <h5 class="create-title my-4">Listas Registradas</h5>
    </div>
    <article>
      <div v-if="!showCreateFontStep1">
        <div
          class="d-flex gap-5 align-items-center my-4 justify-content-between"
        >
          <p
            style="
              margin-top: 20px;
              color: rgb(125, 143, 152);
              text-align: justify;
            "
          >
            Puedes configurar listas de tu catálogo, o subir una nueva.
          </p>
          <div class="d-flex justify-content-center" style="max-height: 2.8rem">
            <button class="globals-button" @click="toggleCreateStep1">
              Crear Lista
            </button>
          </div>
        </div>
        <ListsTable :data="keys" />
      </div>

      <div v-else>
        <CreateFontStep1
          :key="createFontKey"
          @nested-open="handleNestedOpen"
          @nested-close="handleNestedClose"
        />

        <button
          v-if="!cardOpen"
          class="buttons-group d-flex mb-3 align-items-center"
          @click="closeCreateStep1"
        >
          <ChevronLeftIcon
            class="text-blue-500 d-flex justify-content-center"
            style="width: 20px; height: 20px"
          />
          <p class="text">Regresar</p>
        </button>
      </div>
    </article>
  </div>
</template>

<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";

.buttons-group {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    color: $five-color;
  }
}

.text {
  font-size: large;
  font-weight: 600;
  color: $primary-color;
  margin-left: 0.5rem;
  margin-bottom: 0;
  &:hover {
    color: $five-color;
  }
}
</style>
